import {
  Dialog,
  IconButton,
  TableCell,
  TableRow,
  Tooltip,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useState } from "react";
import { Clear } from "@mui/icons-material";
import ConfirmationModal from "../../../App/Components/Modals/ConfirmationModal";
import { callAPI } from "../../../App/Helpers/callApi";
import Signifier from "../../../App/Components/Signifier/Signifier";
import { Link } from "react-router-dom";
import { deactivateEvent, getEvents } from "../EventsService";
import { convertDateWithTime } from "../../../App/Helpers/DateConverters";
import {
  deleteFeaturedEvent,
  getFeaturedEvents,
} from "../../FeaturedEventsPage/FeaturedEventsService";

const useStyles = makeStyles((theme) => ({
  rowCell: {
    cursor: "pointer !important",
    background: theme.palette.primary.blue,
    textDecoration: "none",
    "&:hover": {
      background: "rgba(0,0,0,.2) !important",
    },
  },
  rowCellOdd: {
    cursor: "pointer !important",
    background: "white",
    textDecoration: "none",
    "&:hover": {
      background: "rgba(0,0,0,.2) !important",
    },
  },
  image: {
    maxWidth: "100px",
    height: "auto",
  },
  tableCell: {
    color: theme.palette.primary.copy,
  },
}));

export default function EventsTableCell({
  columns,
  element: event,
  index,
  setTableData,
}) {
  const classes = useStyles();
  const [deleteModal, setDeleteModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [showSignifier, setShowSignifier] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [showError, setShowError] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [featuredEventId, setFeaturedEventId] = useState("");

  const callDeactivateEvent = () => {
    callAPI(
      deactivateEvent(event.id),
      "Event Deactivated",
      setShowSignifier,
      setResponseMessage,
      setShowError,
      setProcessing
    ).then(() => {
      getEvents(event.clientId, false).then((response) => {
        response.eventSponsors.forEach(
          (row) =>
            (row.imagePath = "data:" + row.contentType + ";base64," + row.logo)
        );
        response.events?.forEach((row) => {
          row.displayIsActive = row.isActive ? "Yes" : "No";
          row.startDate = convertDateWithTime(row.startDate);
          row.endDate = convertDateWithTime(row.endDate);
          row.sponsors = response.eventSponsors;
          row.types = response.eventTypes;
          row.venues = response.eventVenues;
          row.timeZones = response.timeZonesCollection;
        });
        setTableData(response.events);
      });
    });

    if (featuredEventId !== "") {
      callDeleteFeaturedEvent();
    }
  };

  const callDeleteFeaturedEvent = () => {
    callAPI(
      deleteFeaturedEvent(featuredEventId),
      "Featured Event Deleted",
      setShowSignifier,
      setResponseMessage,
      setShowError,
      setProcessing
    );
  };

  function openModal(e) {
    e.preventDefault();
    getFeaturedEvents(event.clientId).then((response) => {
      const eventMatch = response.find(
        (featuredEvent) => featuredEvent.eventId === event.id
      );

      if (eventMatch !== undefined) {
        setFeaturedEventId(eventMatch?.id);
      }
      setModalMessage(
        eventMatch !== undefined
          ? "Deactivating this event will also delete it from featured events. Continue?"
          : "Deactivate this event?"
      );
    });

    setDeleteModal(true);
  }

  function closeModal() {
    setFeaturedEventId("");
    setDeleteModal(false);
  }

  return (
    <>
      <Signifier
        showSignifier={showSignifier}
        setShowSignifier={setShowSignifier}
        message={responseMessage}
        error={showError}
      />
      <TableRow
        hover
        className={index % 2 ? classes.rowCell : classes.rowCellOdd}
        key={index}
        component={Link}
        to={{ pathname: "/events/eventdetailed", state: event }}
      >
        {columns.map((column, elementIndex) => (
          <TableCell
            align="left"
            key={elementIndex}
            className={classes.tableCell}
          >
            {column.label === "Deactivate" ? (
              event.isActive ? (
                <Tooltip title="Deactivate Event">
                  <IconButton onClick={(e) => openModal(e)} size="large">
                    <Clear />
                  </IconButton>
                </Tooltip>
              ) : null
            ) : column.label === "Logo" ? (
              <img
                className={classes.image}
                src={event[column.propName]}
                alt="logo"
              />
            ) : (
              event[column.propName]
            )}
          </TableCell>
        ))}
      </TableRow>
      <Dialog open={deleteModal} onClose={() => setDeleteModal(false)}>
        <ConfirmationModal
          question={modalMessage}
          func={() => callDeactivateEvent()}
          closeModal={() => closeModal()}
        />
      </Dialog>
    </>
  );
}
